<template>
    <c-dialog ref="dialog" mode="slide" width="40vw" mask-close
              @close="dialogFormEditConfirm($refs.purchaseCheckForm, arguments)"
              @resolve="submitHandle" :button="!detail">
        <template #head>
            <div v-if="detailData.produce_unique_code" class="m-detail-tag flex-center-cross">
                <label>{{ detailData.produce_unique_code }}</label>
                <c-state tag async dict="UNIQUE_CODE_STATE" :value="detailData.state"></c-state>
            </div>
        </template>
        <c-form ref="purchaseCheckForm" column="1" vertical unit-width="100%">
            <c-form link-parent>
                <c-form-item label="IMEI码" required>
                    <c-input name="produce_imei" placeholder="请输入，不填将自动生成" :disabled="detail"></c-input>
                </c-form-item>
                <c-form-item label="类目" required>
                    <template #default="{data}">
                        <c-select name="category_id"
                                  async @search="searchCategory"
                                  @change="changeSelect($event, detailData,'categoryId')"
                                  :value-data="detailData.productCategory"
                                  v-model="detailData.category_id"
                                  :disabled="detail"
                                  :clear="false">
                            <template #option="{data, selected}">
                                <select-option :name="data.name" :selected="selected"></select-option>
                            </template>
                        </c-select>
                    </template>
                </c-form-item>
                <c-form-item label="品牌" required>
                    <template #default="{data}">
                        <c-select name="brand_id"
                                  async @search="searchBrand(detailData,arguments[0], arguments[1])"
                                  @change="changeSelect($event, detailData,'brandId')"
                                  :value-data="detailData.productBrand"
                                  v-model="detailData.brand_id"
                                  :disabled="!detailData.category_id || detail"
                                  :clear="false">
                            <template #option="{data, selected}">
                                <select-option :name="data.name" :selected="selected"></select-option>
                            </template>
                        </c-select>
                    </template>
                </c-form-item>
                <c-form-item label="机型" required>
                    <template #default="{data}">
                        <c-select name="spu_model_id"
                                  async @search="searchModel(detailData,arguments[0], arguments[1])"
                                  @change="changeSelect($event, detailData,'modelId')"
                                  :value-data="detailData.productModel"
                                  v-model="spuModelId"
                                  :disabled="!detailData.brand_id || detail"
                                  :clear="false">
                            <template #option="{data, selected}">
                                <select-option :name="data.name" :selected="selected"></select-option>
                            </template>
                        </c-select>
                    </template>
                </c-form-item>
                <c-form-item label="等级" required>
                    <c-radio-group name="level_type" v-model="detailData.level_type" :options="levelTypeOptions"
                                   :disabled="detail"></c-radio-group>
                </c-form-item>
                <c-form-item label="演示机" required>
                    <c-radio-group name="is_demo" v-model="detailData.is_demo" :options="yesOrNoOptions"
                                   :disabled="detail"></c-radio-group>
                </c-form-item>
                <!--其他动态属性-->
                <c-form v-show="attributeList && attributeList.length" ref="form" name="attribute_value_json"
                        link-parent>
                    <c-form-item v-for="(item, i) in attributeList" :key="i" :label="item.attribute_name" :required="item.required==1">
                        <c-input v-if="item.attribute_type == 2"
                                 type="number"
                                 :name="'attribute_parent_id_'+item.parent_id"
                                 :decimal="item.decimal ? item.decimal : 0"
                                 :disabled="detail"
                        ></c-input>

                        <c-datetime v-else-if="item.attribute_type == 3"
                                    :name="'attribute_parent_id_'+item.parent_id"
                                    :type="item.config_json.format.split('|')[1]"
                                    :format="item.config_json.format.split('|')[0]"
                                    :time-accuracy="item.config_json.format.split('|')[2]"
                                    :disabled="detail"
                        ></c-datetime>

                        <template v-else-if="item.attribute_type == 4">
                            <c-radio-group :name="'attribute_parent_id_'+item.parent_id" :options="item.attribute_options" :disabled="detail">
                            </c-radio-group>
                        </template>

                        <c-upload-file v-else-if="item.attribute_type == 5"
                                       :name="'attribute_parent_id_'+item.parent_id"
                                       type="file"
                                       :multiple="(item.config_json.multiple && item.config_json.multiple == 1) ? 30 : false"
                                       :disabled="detail"
                        ></c-upload-file>

                        <c-upload-file v-else-if="item.attribute_type == 6"
                                       :name="'attribute_parent_id_'+item.parent_id"
                                       type="image"
                                       :multiple="(item.config_json.multiple && item.config_json.multiple == 1) ? 30 : false"
                                       :disabled="detail"
                        ></c-upload-file>

                        <c-input v-else
                                 type="text"
                                 :name="'attribute_parent_id_'+item.parent_id"
                                 :disabled="detail"
                        ></c-input>
                    </c-form-item>
                </c-form>
            </c-form>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'purchaseOrderCheck',
    computed: {
		...mapState(['yesOrNoOptions']),
        //自定义参数必填校验
        rule() {
            let rule = {};
            this.attributeList.map(item => {
                if (item.required == 1) {
                    rule[`attribute_value_json.attribute_parent_id_${item.parent_id}`] = `${item.attribute_name}不能为空`;
                }
            });
            return rule;
        },
    },
    data() {
        return {
            detail: false,             //是否仅查看 1=仅查看
            produce_unique_code: '',//背贴码信息
            produce_code_id: 0,//背贴码ID
            detailData: {},
            levelTypeOptions: [],
            attributeList: [],
            spuModelId: 0,
            selctedAttributeMap: {}
        }
    },

    watch: {
    },

    methods: {
        initData() {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code: 'LEVEL_TYPE'
                },
                success: data => {
                    this.levelTypeOptions = data;
                }
            })
        },
        /*******通过商品的【机型】查询该机型需要填写的参数集合*******************/
        getAttributeListByModel(init_type) {
            this.request({
                url: '/spu/model/attribute/list',
                data: {
                    type: 1,            //默认使用B端数据
                    model_id: this.spuModelId
                },
                loading: true,
                success: data => {
                    this.attributeList = data;
                    if (init_type){
                        //赋值已选中的属性
                        setTimeout(() => {
                            //合并对象
                            const mergedObj = Object.assign({}, this.detailData, this.detailData.attribute_value_json);
                            //采购订单基本信息
                            this.$refs.purchaseCheckForm.set(mergedObj);
                        }, 50);
                    }
                }
            });
        },
        //打开弹窗
        open(detail, data) {
            this.detail = detail;
            this.produce_unique_code = data.produce_unique_code;
            //清空表单数据
            this.$refs.purchaseCheckForm.clear();
            this.initData();
            //查询详情
            this.getPurchaseOrderProductDetail();
            this.$refs.dialog.open({
                title: detail ? '采购商品详情' : '完善初检'
            });
        },
        /**************变更 下拉框数据******************/
        changeSelect(selectData, rowData, type) {
            if (type == 'categoryId') {
                if (selectData && selectData.value) {
                    rowData.brand_id = 0;
                    rowData.productbrand = [];
                    rowData.spu_model_id = 0;
                    rowData.productModel = [];
                    rowData.memory_id = 0;//内存ID
                    rowData.color_id = 0;//颜色ID
                }
            } else if (type == 'brandId') {
                if (selectData && selectData.value) {
                    rowData.spu_model_id = 0;
                    rowData.memory_id = 0;//内存ID
                    rowData.color_id = 0;//颜色ID
                    rowData.productModel = [];
                }
            } else if (type == 'modelId') {
                if (selectData && selectData.value) {
                    rowData.memory_id = 0;//内存ID
                    rowData.color_id = 0;//颜色ID
                    this.getAttributeListByModel();
                }
            }
        },
        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索品牌****************/
        searchBrand(data, keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: data.category_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索机型****************/
        searchModel(data, keyword, resolve) {
            this.request({
                url: '/spu/model/options',
                data: {
                    category_id: data.category_id,
                    brand_id: data.brand_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索采购商品详情*******************/
        getPurchaseOrderProductDetail() {
            this.request({
                url: '/purchase/order/product/detail',
                data: {
                    produce_unique_code: this.produce_unique_code
                },
                loading: true,
                success: data => {
                    data.level_type = data.level_type||'';
                    this.detailData = data||{};
                    this.produce_code_id = this.detailData.id;
                    this.spuModelId = this.detailData.spu_model_id || 0;
                    this.selctedAttributeMap = this.detailData.selctedAttributeMap || {};
                    if(this.spuModelId){
                        this.getAttributeListByModel(true);
                    }
                    //合并对象
                    const mergedObj = Object.assign({}, this.detailData, this.detailData.attribute_value_json);
                    //采购订单基本信息
                    this.$refs.purchaseCheckForm.set(mergedObj);
                }
            });
        },

        /*******提交编辑数据********************/
        submitHandle(stop, next) {
            stop();
            this.$refs.purchaseCheckForm.submit({
                url: '/product/unique_code/check',
                rule: {
                    category_id: '请选择类目',
                    brand_id: '请选择品牌',
                    spu_model_id: '请选择机型',
                    level_type: '请选择等级',
                    ...this.rule
                },
                dataFormatter: data => {
                    data.produce_code_id = this.produce_code_id;
                    return data;
                },
                success: () => {
                    next();
                    this.$message({
                        type: 'success',
                        message: '初检数据录入成功',
                    });
                    //刷新页面
                    this.$emit('resolve');
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>